// extracted by mini-css-extract-plugin
module.exports = {"Header":"Courses_Header__KU__A","signed":"Courses_signed__FnA2n"};